import { render, staticRenderFns } from "./comment-list.vue?vue&type=template&id=ce1e9862"
import script from "./comment-list.vue?vue&type=script&lang=js"
export * from "./comment-list.vue?vue&type=script&lang=js"
import style0 from "./comment-list.vue?vue&type=style&index=0&id=ce1e9862&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports